import { useEffect, useState } from 'react';
import styles from './Termos.module.css';
import Footer from '../Footer';
import Header from '../Header';
import { SegmentedControl } from '../../../ui';

const ULTIMA_ATUALIZACAO = '16 de julho de 2026';
const EMAIL_CONTATO = 'contato@finant.com.br';

/**
 * Termos de Uso + Política de Privacidade (LGPD).
 * Responsável: Leonardo Tosin — Novo Mundo, Curitiba/PR.
 */
export default function Termos() {
  const [documento, setDocumento] = useState('termos');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [documento]);

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <Header esconder={true} onLogin={() => null} onCreateAccount={() => null} atualizar={false} onAtualizar={() => null} />

        <div className={styles.cabecalho}>
          <h1 className={styles.titulo}>Termos e Políticas</h1>
          <p className={styles.atualizacao}>Última atualização: {ULTIMA_ATUALIZACAO}</p>
          <div className={styles.seletor}>
            <SegmentedControl
              opcoes={[
                { id: 'termos', rotulo: 'Termos de Uso', icone: 'gavel' },
                { id: 'privacidade', rotulo: 'Política de Privacidade', icone: 'shield_person' }
              ]}
              valor={documento}
              onChange={setDocumento}
            />
          </div>
        </div>

        {documento === 'termos' ? (
          <article className={styles.documento}>
            <h2 className={styles.topico}>1. Quem somos e o que você está aceitando</h2>
            <p className={styles.texto}>
              O Finant é uma plataforma digital de controle financeiro pessoal, desenvolvida e mantida por
              <strong> Leonardo Tosin</strong> ("nós"), com endereço no bairro Novo Mundo, Curitiba/PR, Brasil.
              Canal oficial de contato: <strong>{EMAIL_CONTATO}</strong>.
            </p>
            <p className={styles.texto}>
              Ao criar uma conta ou utilizar o Finant, você declara que leu, entendeu e concorda com estes Termos de
              Uso e com a Política de Privacidade, que formam um único acordo entre você e nós. Se não concordar com
              qualquer condição, não utilize a plataforma.
            </p>

            <h2 className={styles.topico}>2. O que o Finant é (e o que ele não é)</h2>
            <p className={styles.texto}>
              O Finant permite registrar manualmente receitas e despesas, organizar contas, cartões de crédito e
              categorias, definir metas de orçamento e acompanhar dashboards, projeções e relatórios sobre a sua vida
              financeira.
            </p>
            <div className={styles.destaque}>
              O Finant <strong>não é uma instituição financeira</strong>: não movimenta dinheiro, não processa
              pagamentos, não se conecta a bancos nem importa extratos automaticamente. Também{' '}
              <strong>não presta consultoria financeira, contábil ou de investimentos</strong>: tudo o que a
              plataforma exibe é calculado exclusivamente a partir dos dados que você mesmo insere.
            </div>

            <h2 className={styles.topico}>3. Cadastro, conta e segurança de acesso</h2>
            <p className={styles.texto}>
              Para usar o Finant você precisa criar uma conta com nome, e-mail e senha, fornecendo informações
              verdadeiras. O serviço é destinado a maiores de 18 anos.
            </p>
            <p className={styles.texto}>
              Sua senha é armazenada exclusivamente na forma de hash criptográfico (bcrypt), nunca em texto puro, e
              a autenticação é feita pelos nossos próprios servidores. Quem criou a conta com login do Google pode
              definir uma senha própria a qualquer momento pelo fluxo "esqueci minha senha", que envia um link seguro
              por e-mail.
            </p>
            <p className={styles.texto}>
              A conta é pessoal e intransferível. Você é responsável por manter suas credenciais em sigilo e deve nos
              avisar imediatamente em {EMAIL_CONTATO} caso suspeite de uso indevido.
            </p>

            <h2 className={styles.topico}>4. Gratuidade e eventuais planos futuros</h2>
            <p className={styles.texto}>
              O Finant é oferecido gratuitamente na data desta versão dos termos. Podemos, no futuro, criar planos
              pagos, limitar funcionalidades do plano gratuito ou alterar a oferta do serviço. Nesse caso, você será
              avisado com antecedência razoável, de forma clara, e <strong>nenhuma cobrança será feita sem o seu
              consentimento expresso</strong>. Estes termos não constituem promessa de gratuidade por prazo
              indeterminado.
            </p>

            <h2 className={styles.topico}>5. Uso aceitável</h2>
            <p className={styles.texto}>É proibido, entre outros:</p>
            <ul className={styles.lista}>
              <li>tentar acessar contas, dados ou áreas da infraestrutura que não sejam suas;</li>
              <li>explorar falhas, aplicar engenharia reversa ou sobrecarregar intencionalmente o serviço;</li>
              <li>usar a plataforma para atividade ilícita ou que viole direitos de terceiros;</li>
              <li>revender, sublicenciar ou disponibilizar o serviço a terceiros sem autorização por escrito.</li>
            </ul>
            <p className={styles.texto}>
              Podemos suspender ou encerrar contas envolvidas em violação destes termos, mediante aviso quando
              cabível.
            </p>

            <h2 className={styles.topico}>6. Propriedade intelectual e seus dados</h2>
            <p className={styles.texto}>
              A marca Finant, o código, o design e os demais elementos da plataforma pertencem ao desenvolvedor. Os
              dados financeiros que você registra <strong>são seus</strong>: você apenas nos autoriza a processá-los
              na medida necessária para prestar o serviço, conforme a Política de Privacidade.
            </p>

            <h2 className={styles.topico}>7. Disponibilidade, falhas e cópias de segurança</h2>
            <p className={styles.texto}>
              A plataforma é fornecida "no estado em que se encontra". Trabalhamos para mantê-la estável e disponível,
              mas não garantimos operação ininterrupta ou livre de falhas: manutenções, atualizações e eventos fora
              do nosso controle podem causar indisponibilidade temporária. Mantemos rotinas razoáveis de cópia de
              segurança, mas recomendamos que você guarde por conta própria registros essenciais.
            </p>

            <h2 className={styles.topico}>8. Limitação de responsabilidade</h2>
            <p className={styles.texto}>
              As decisões financeiras tomadas com base nas informações da plataforma são de sua exclusiva
              responsabilidade. Na máxima extensão permitida pela lei, não respondemos por lucros cessantes ou danos
              indiretos decorrentes do uso ou da indisponibilidade do serviço. Nada nestes termos exclui
              responsabilidades que a legislação brasileira, incluindo o Código de Defesa do Consumidor, não permita
              excluir.
            </p>

            <h2 className={styles.topico}>9. Encerramento da conta</h2>
            <p className={styles.texto}>
              Você pode parar de usar o Finant quando quiser e solicitar a exclusão definitiva da sua conta e dos seus
              dados pelo e-mail {EMAIL_CONTATO}. Os detalhes de prazos e retenção estão na Política de Privacidade.
            </p>

            <h2 className={styles.topico}>10. Alterações destes termos</h2>
            <p className={styles.texto}>
              Estes termos podem ser atualizados. Mudanças relevantes serão comunicadas na própria plataforma e/ou por
              e-mail com antecedência razoável; a versão vigente estará sempre publicada nesta página. O uso
              continuado após a vigência de uma nova versão significa concordância com ela.
            </p>

            <h2 className={styles.topico}>11. Lei aplicável e foro</h2>
            <p className={styles.texto}>
              Este acordo é regido pelas leis brasileiras. Fica eleito o foro da comarca de Curitiba/PR, ressalvado ao
              consumidor o direito de optar pelo foro do seu domicílio, nos termos da lei.
            </p>

            <h2 className={styles.topico}>12. Contato</h2>
            <p className={styles.texto}>
              Dúvidas, sugestões ou suporte: <strong>{EMAIL_CONTATO}</strong>.
            </p>
          </article>
        ) : (
          <article className={styles.documento}>
            <h2 className={styles.topico}>1. Quem é o responsável pelos seus dados</h2>
            <p className={styles.texto}>
              O controlador dos dados pessoais tratados pelo Finant, nos termos da Lei Geral de Proteção de Dados
              (Lei nº 13.709/2018, a LGPD), é <strong>Leonardo Tosin</strong>, bairro Novo Mundo, Curitiba/PR, Brasil.
              O canal do encarregado pelo tratamento de dados é o e-mail <strong>{EMAIL_CONTATO}</strong>.
            </p>

            <h2 className={styles.topico}>2. Quais dados coletamos</h2>
            <ul className={styles.lista}>
              <li>
                <strong>Dados de cadastro:</strong> nome, e-mail e senha (armazenada somente como hash bcrypt).
                Telefone e data de aniversário são opcionais.
              </li>
              <li>
                <strong>Dados financeiros inseridos por você:</strong> transações, contas, cartões, categorias e
                metas, registrados manualmente ou importados por você via PDF. O Finant não se conecta a bancos.
              </li>
              <li>
                <strong>Registros técnicos:</strong> logs de acesso à aplicação (endereço IP, data e hora), mantidos
                por obrigação legal do Marco Civil da Internet (Lei nº 12.965/2014).
              </li>
              <li>
                <strong>Preferências locais:</strong> tema, cor de destaque e o token da sua sessão ficam no
                armazenamento local do seu navegador (localStorage). Não usamos cookies de publicidade nem
                rastreadores de terceiros.
              </li>
            </ul>

            <h2 className={styles.topico}>3. Para que usamos e com quais bases legais</h2>
            <ul className={styles.lista}>
              <li>
                <strong>Prestar o serviço</strong> (execução de contrato): autenticar seu acesso, armazenar e exibir
                seus registros, calcular dashboards, metas e projeções.
              </li>
              <li>
                <strong>Cumprir obrigações legais:</strong> guarda de logs de acesso pelo prazo exigido em lei.
              </li>
              <li>
                <strong>Segurança e melhoria</strong> (legítimo interesse): prevenção a fraudes e abuso, diagnóstico de
                erros e evolução do produto.
              </li>
              <li>
                <strong>Comunicações:</strong> hoje enviamos apenas e-mails transacionais: definição/redefinição de
                senha e avisos sobre a sua conta. Comunicações não essenciais, se um dia existirem, dependerão do seu
                consentimento.
              </li>
            </ul>

            <h2 className={styles.topico}>4. Com quem os dados são compartilhados</h2>
            <p className={styles.texto}>
              <strong>Não vendemos nem alugamos seus dados.</strong> Compartilhamos dados apenas com operadores de
              infraestrutura estritamente necessários para o serviço funcionar: provedores de hospedagem em nuvem
              (aplicação e banco de dados) e de envio de e-mail transacional, todos vinculados a obrigações de
              confidencialidade e proteção de dados, e com autoridades públicas quando houver obrigação legal.
              Integrações que você mesmo conectar à sua conta, quando disponíveis, acessam seus dados somente sob a
              sua autorização e podem ser revogadas por você.
            </p>
            <p className={styles.texto}>
              <strong>Importação de documentos por IA:</strong> se você optar por importar uma fatura ou um extrato em
              PDF, o documento é enviado a um operador de inteligência artificial (Anthropic) com a única finalidade
              de extrair os lançamentos para a sua revisão. O PDF é processado e <strong>descartado em seguida</strong>:
              não fica armazenado por nós e o operador não o utiliza para treinar modelos. Nenhum lançamento entra na
              sua conta sem a sua confirmação, e o uso do recurso é sempre opcional e iniciado por você.
            </p>

            <h2 className={styles.topico}>5. Como protegemos os dados</h2>
            <p className={styles.texto}>
              Usamos criptografia em trânsito (TLS/HTTPS), senha armazenada com hash bcrypt, autenticação por token
              com expiração e acesso restrito ao banco de dados. Nenhum sistema é 100% imune: caso ocorra incidente de
              segurança com risco relevante aos titulares, comunicaremos os afetados e a ANPD conforme a LGPD.
            </p>

            <h2 className={styles.topico}>6. Por quanto tempo guardamos</h2>
            <p className={styles.texto}>
              Seus dados são mantidos enquanto a sua conta existir. Após a confirmação do pedido de exclusão, os dados
              pessoais e financeiros são removidos definitivamente dos sistemas ativos, ressalvados os registros cuja
              guarda é exigida por lei (como logs de acesso, por 6 meses) e cópias de segurança, que expiram em ciclo
              curto de rotina.
            </p>

            <h2 className={styles.topico}>7. Seus direitos (art. 18 da LGPD)</h2>
            <p className={styles.texto}>
              Você pode solicitar a qualquer momento: confirmação do tratamento, acesso, correção, anonimização,
              portabilidade, eliminação dos dados, informação sobre compartilhamentos e revogação de consentimento.
              Basta escrever para <strong>{EMAIL_CONTATO}</strong>; respondemos em prazo razoável e sem custo. Você
              também pode peticionar à Autoridade Nacional de Proteção de Dados (ANPD).
            </p>

            <h2 className={styles.topico}>8. Crianças e adolescentes</h2>
            <p className={styles.texto}>
              O Finant não é destinado a menores de 18 anos. Se identificarmos cadastro de menor, os dados serão
              excluídos.
            </p>

            <h2 className={styles.topico}>9. Transferência internacional</h2>
            <p className={styles.texto}>
              Nossos provedores de nuvem podem armazenar dados em servidores localizados fora do Brasil. Nesses casos,
              a transferência ocorre para países ou mediante salvaguardas que atendem aos requisitos do art. 33 da
              LGPD.
            </p>

            <h2 className={styles.topico}>10. Alterações desta política</h2>
            <p className={styles.texto}>
              Esta política pode ser atualizada para refletir mudanças no produto ou na legislação. A versão vigente,
              com a data de atualização, estará sempre publicada nesta página; mudanças relevantes serão avisadas na
              plataforma e/ou por e-mail.
            </p>
          </article>
        )}

        <Footer esconder={true} />
      </div>
    </div>
  );
}
